var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.deliverable
    ? _c(
        "div",
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.addDepartmentFlag,
                  expression: "!addDepartmentFlag"
                }
              ],
              staticClass: "pb-0 titles exclude-outside-click",
              on: { click: _vm.showAddDepartment }
            },
            [
              _vm._l(_vm.deliverable.departments, function(department, index) {
                return _c(
                  "div",
                  {
                    key: "deliverable-modal-department-" + department.id,
                    staticClass: "department-title exclude-outside-click"
                  },
                  [
                    index > 0
                      ? _c("span", { staticClass: "department--separator" }, [
                          _vm._v(" &")
                        ])
                      : _vm._e(),
                    _vm._v(" " + _vm._s(department.name) + "\n    ")
                  ]
                )
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.hasDepartments(),
                      expression: "!hasDepartments()"
                    }
                  ],
                  staticClass: "department-title exclude-outside-click"
                },
                [_vm._v("No Department")]
              ),
              _vm._v(" "),
              _c("plus-button", { staticClass: "tagged-departments" })
            ],
            2
          ),
          _vm._v(" "),
          _c("multiselect", {
            directives: [
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: _vm.outside,
                expression: "outside"
              },
              {
                name: "show",
                rawName: "v-show",
                value: _vm.addDepartmentFlag,
                expression: "addDepartmentFlag"
              }
            ],
            ref: "deliverableDepartments",
            attrs: {
              "close-on-select": true,
              options: _vm.allActiveDepartments,
              "show-labels": false,
              multiple: true,
              taggable: false,
              label: "name",
              "track-by": "id",
              id: _vm.deliverable.deliverableId
            },
            on: {
              input: function($event) {
                return _vm.updateProjectFieldValue(_vm.deliverable)
              },
              close: function($event) {
                _vm.addDepartmentFlag = false
              }
            },
            model: {
              value: _vm.deliverable.departments,
              callback: function($$v) {
                _vm.$set(_vm.deliverable, "departments", $$v)
              },
              expression: "deliverable.departments"
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }